//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "tags",
  data() {
    return {
      chips: [
        {
        title: 'Библиотека',
        link: 'https://library.hse.ru'
        },
        {
        title: 'Издательский дом',
        link: 'https://id.hse.ru'
        },
        {
        title: 'Книжный магазин',
        link: 'https://bookshop.hse.ru'
        },
        {
        title: 'Магазин HSE Store',
        link: 'https://id.hse.ru'
        },
        {
        title: 'Типография',
        link: 'https://print.hse.ru'
        },
        {
        title: 'Журналы',
        link: 'https://id.hse.ru/journals/'
        },
        {
        title: 'Публикации',
        link: 'https://publications.hse.ru'
        },
        {
        title: 'Медиацентр',
        link: 'https://mc.hse.ru'
        },
        {
        title: 'Университет открытый городу',
        link: 'https://moscow.hse.ru'
        },
        {
        title: 'Единый архив',
        link: 'http://sophist.hse.ru'
        },             
        ]
    }
  }
}
